import React from 'react';
import logo from '../../assets/images/logo_logistics.png';
import { checkOriginNonProd } from '../../utils/util';
import ListLinkBox from '../../components/UI/ListLinkBox';

const Home = () => {
    const menu = () => {
        let menuItems = [];
        menuItems = [...menuItems, { route: 'config/user', icon: 'chrome_reader_mode', text: "Recurso Padrão Logistics" }];
        return menuItems;
    };

    return (
        <>
            <div className="container" style={{ marginLeft: '5px', marginTop: '40px', }}>
                <ListLinkBox
                    options={menu()}
                />
            </div>
            <div className="center">
                <img src={`${logo}`} style={{ paddingTop: '30%', opacity: '0.3' }} alt="Logo Logistics" />
                {
                    checkOriginNonProd(window) ? (<div><br /> <span className="black-text">Environment: NONPROD</span></div>) : null
                }
            </div>
        </>

    );
}

export default Home;
